module.exports = __webpack_public_path__ + "static/media/video-one.8143f52b.jpg";